module.exports = __webpack_public_path__ + "media/images/a_four-ca9e340350e726c5d29288363b0cbc46.png";